import { Currency } from '../store/config/enums';

export const currencyHelper = {
  getCurrencyToken,
  getCurrencyName,
  mapCurrency,
  isValidCurrency,
  formatCurrencyToNumber,
  getAllowedCurrencies,
  getAllowedCurrencyOptions,
  getDefaultAllowedCurrency,
};

function getCurrencyToken(currency: Currency): string {
  if (currency === Currency.PESO) {
    return '$';
  } else {
    return 'USD';
  }
}

function getCurrencyName(currency: Currency, urlFriendly: boolean = false): string | undefined {
  if (currency === Currency.PESO) {
    return urlFriendly ? 'pesos' : 'Pesos';
  } else if (currency === Currency.DOLAR) {
    return urlFriendly ? 'dolares' : 'Dólares';
  } else {
    return undefined;
  }
}

type EnumType = { [s: number]: string };

function mapCurrency(enumerable: EnumType, fn: Function): any[] {
  // get all the members of the enum
  let enumMembers: any[] = Object.keys(enumerable).map((key: any) => enumerable[key]);

  // we are only interested in the numeric identifiers as these represent the values
  let enumValues: number[] = enumMembers.filter((v) => typeof v === 'number');

  // now map through the enum values
  return enumValues.map((m) => fn(m));
}

function isValidCurrency(currency: number) {
  return currency === Currency.PESO || currency === Currency.DOLAR;
}

function formatCurrencyToNumber(currency: string): string {
  const normalizedCurrencyName = currency
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  if (normalizedCurrencyName === 'pesos') {
    return Currency.PESO.toString();
  }

  if (normalizedCurrencyName === 'dolares') {
    return Currency.DOLAR.toString();
  }

  return currency;
}

interface LinkCurrencySettings {
  canCreateLinksInPesos?: boolean;
  canCreateLinksInDollars?: boolean;
  defaultLinkCurrency?: Currency;
}

function getAllowedCurrencies(settings?: LinkCurrencySettings): Currency[] {
  const canCreateLinksInPesos = settings?.canCreateLinksInPesos ?? true;
  const canCreateLinksInDollars = settings?.canCreateLinksInDollars ?? true;
  const currencies: Currency[] = [];

  if (canCreateLinksInPesos) {
    currencies.push(Currency.PESO);
  }

  if (canCreateLinksInDollars) {
    currencies.push(Currency.DOLAR);
  }

  return currencies.length > 0 ? currencies : [Currency.PESO];
}

function getAllowedCurrencyOptions(settings?: LinkCurrencySettings): { id: Currency; value: string }[] {
  return getAllowedCurrencies(settings).map((currency) => ({
    id: currency,
    value: `${getCurrencyName(currency)}`,
  }));
}

function getDefaultAllowedCurrency(settings?: LinkCurrencySettings): Currency {
  const allowedCurrencies = getAllowedCurrencies(settings);
  const preferredCurrency = settings?.defaultLinkCurrency;
  return preferredCurrency !== undefined && allowedCurrencies.includes(preferredCurrency)
    ? preferredCurrency
    : allowedCurrencies[0];
}
